export const groupColors = {
  Green: "#51b87b",
  Earthy: "#51b87b",
  Alcohol: "#00b9ac",
  "Fruit Like": "#51b87b",
  Herbacious: "#51b87b",
  Citrus: "#8f0c3f",
  "Dried Fruit": "#8f0c3f",
  Savoury: "#80b352",
  Dairy: "#3d3d6a",
  Sulphur: "#246985",
  Berry: "#8f0c3f",
  "Tree Fruit": "#8f0c3f",
  Tropical: "#8f0c3f",
  Phenol: "#c60039",
  Melon: "#8f0c3f",
  Chocolate: "#fe8c1a",
  Meaty: "#fe8c1a",
  Nutty: "#fe8c1a",
  Caramel: "#fe8c1a",
  Pungent: "#fe5733",
  Toasted: "#fe8c1a",
  Roasted: "#fe8c1a",
  Spice: "#fec200",
  Marine: "#ecdc53",
  Sour: "#acd35b",
  Wood: "#fec200",
  Smoke: "#fec200",
  Petrol: "#fec200",
  Floral: "#491541",
  Medicinal: "#fec200",
};
